import { render, staticRenderFns } from "./ManageStorageModal.vue?vue&type=template&id=52452b36&scoped=true"
import script from "./ManageStorageModal.vue?vue&type=script&lang=ts"
export * from "./ManageStorageModal.vue?vue&type=script&lang=ts"
import style0 from "./ManageStorageModal.vue?vue&type=style&index=0&id=52452b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52452b36",
  null
  
)

export default component.exports